<template>
  <qx-card title="列表">
    <UploadFileDialog ref="uploadFileDialog" />
    <LogRightDialog ref="logRightDialog" busiCode="21000022" />
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
      <qx-permpisions permpisions="">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="oaLoan.ajax?cmd=queryOaLoan"
          :params="fullSearchData"
          bizName="员工借支列表导出"
          bizCode="exp100033"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
            :fixed="item.prop === 'oaLoanId'"
          >
            <section slot-scope="scope">
              <section
                v-if="scope.column.property === 'oaLoanId'"
                @click="toDetail(scope.row, '员工借支详情')"
              >
                <span class="primary cur">{{
                  scope.row[scope.column.property]
                }}</span>
              </section>
              <section
                v-if="scope.column.property === 'plateNumber'"
                @click="toCarDetail(scope.row)"
              >
                <span class="primary cur">{{
                  scope.row[scope.column.property]
                }}</span>
              </section>
              <section
                v-if="
                  scope.column.property !== 'oaLoanId' &&
                  scope.column.property !== 'plateNumber'
                "
              >
                {{ scope.row[scope.column.property] }}
              </section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="160"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    showCondition:
                      scope.row.isHasPermission &&
                      (scope.row.sts === 1 || scope.row.sts === 0),
                    name: '审核',
                    event: () => toDetail(scope.row, '审核员工借支', 'approve'),
                  },
                  {
                    showCondition:
                      scope.row.launch === 1 &&
                      (scope.row.sts === 0 || scope.row.sts === 2),
                    name: '修改',
                    event: () => toEdit(scope.row.LId),
                  },
                  {
                    showCondition: scope.row.sts === 3 || scope.row.sts === 4,
                    name: '核销',
                    event: () =>
                      toDetail(scope.row, '员工借支核销', 'cancellation'),
                  },
                  {
                    showCondition: scope.row.sts >= 3 && scope.row.sts !== 8,
                    name: '上传附件',
                    event: () => showUploadFileDialog(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.LId),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import ExportBtn from 'components/exportBtn';
import UploadFileDialog from './uploadFileDialog';
import TableBtn from 'components/tableBtn/tableBtn';
import {
  borrowList,
} from 'api/cost';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ExportBtn,
    UploadFileDialog,
    TableBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'oaLoanId',
            label: '借支号码',
          },
          {
            prop: 'orgName',
            label: '归属部门',
          },
          {
            prop: 'userName',
            label: '申请人',
          },
          {
            prop: 'appDate',
            label: '申请时间',
          },
          {
            prop: 'loanSubjectName',
            label: '借支类型',
          },
          {
            prop: 'orderId',
            label: '订单号码',
          },
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'amountDouble',
            label: '借支金额',
          },
          {
            prop: 'payedAmountDouble',
            label: '已核销金额',
          },
          {
            prop: 'isNeedBillName',
            label: '借支票据',
          },
          {
            prop: 'stateName',
            label: '借支状态',
          },
          {
            prop: 'flowId',
            label: '支付流水号',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: borrowList,
    showUploadFileDialog (item) {
      this.$refs.uploadFileDialog.show(item);
    },
    toEdit (id) {
      this.jump({
        label: id ? '修改员工借支' : '新增员工借支',
        url: `/manage/cost/borrow/worker/edit${id ? '?id=' + id : ''}`,
        full: true,
      });
    },
    toDetail (item, label, type = '') {
      this.jump({
        label,
        url: `/manage/cost/borrow/worker/detail?id=${item.LId}&type=${type}`,
        full: true,
      });
    },
    showLog (customerId) {
      this.$refs.logRightDialog.show(customerId);
    },
    toCarDetail (item) {
      this.jump({
        label: `查看车辆${item.plateNumber ? ('-' + item.plateNumber) : ''}`,
        url: `/manage/car/archives/my/detailRecord?plateNumber=${encodeURIComponent(item.plateNumber)}`,
        full: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
